import { ReactNode, createContext } from "react";

// TEXT

// STYLES

// DATA

// TYPES
export type PanelContextType = {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
};

export type Props = {
  children: ReactNode;
  /**
   * Whether the panel should be open by default.
   * @default false
   */
  defaultOpen?: boolean;
};

// CONSTANTS
export const PanelContext = createContext<PanelContextType | undefined>(
  undefined,
);

// FUNCTIONS

// ASSETS
